<template>
  <v-layout>
    <div class="modal">
      <v-dialog :value="value" persistent @input="$emit('input')" transition="fade-transition" fullscreen no-click-animation>
        <v-card>
          <div class="modal-content">
            <v-toolbar color="#3F3FFF" :elevation="1">
              <v-toolbar-title>
                <!-- <h2 class="headline text-xs-center">
                  Pair influencers for campaign:
                  <strong>{{ campaign.name }}</strong>
                </h2> -->
                <v-text-field
                  label="Enter Title"
                  hide-details
                  v-model="infListTitle"
                  class="pairing-list-title-input col-12 mt-3 pr-2 float-left"
                  style="min-width:250px;"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="close">
                <v-icon color="white">close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-container fluid>
              <v-layout column>
                <v-row style="justify-content:center;">
                  <v-col class="col-md-5 col-xs-5" align="center">
                    <h3 class="mb-1">Find influencers manually</h3>
                    <!-- <v-radio-group row v-model="searchType">
                      <v-radio
                        color="success"
                        label="Search by Handle"
                        :value="SearchTypeEnum.HANDLE"
                      ></v-radio>
                      <v-radio
                        color="success"
                        label="Search by keyword"
                        :value="SearchTypeEnum.KEYWORD"
                      ></v-radio>
                      <v-radio
                        color="success"
                        label="Bulk Upload"
                        :value="SearchTypeEnum.BULKUPLOAD"
                      ></v-radio>
                    </v-radio-group>
                    <v-btn color="secondary" class="float-left" @click="$refs.igBulkHandle.click()" v-if="searchType === SearchTypeEnum.BULKUPLOAD" large>
                      <v-icon left>mdi-home-import-outline</v-icon>Import Excel
                    </v-btn>
                    <v-btn color="warning" class="ml-2 float-left" @click="downloadSampleUpload" v-if="searchType === SearchTypeEnum.BULKUPLOAD" large>
                      <v-icon left>mdi-file-excel</v-icon>Download Sample Import
                    </v-btn> -->
                    <v-text-field
                      :label="searchInfluencer === 'Youtube' ? 'Enter Handle' : 'Enter handle'"
                      v-if="searchType === SearchTypeEnum.HANDLE"
                      hide-details
                      v-model="igHandle"
                      @keyup.enter.native="searchManually(searchType)"
                      class="col-8 mt-3 pr-2 float-left"
                      outlined
                    ></v-text-field>
                    <v-select
                      class="col-4 mt-3 float-left"
                      v-model="searchInfluencer"
                      :items="searchInfluencerTypes"
                      v-if="searchType === SearchTypeEnum.HANDLE"
                      outlined
                      attach
                    ></v-select>
                    <input
                      type="file"
                      accept=".xlsx"
                      id="igBulkHandle"
                      ref="igBulkHandle"
                      style="display: none"
                      @change="igHandleBulkUpload"
                    />
                    <k-influencer-search-box
                      v-if="searchType === SearchTypeEnum.KEYWORD"
                      :search="searchKeywordAction"
                      @result="resultFromSearchKeyword"
                    ></k-influencer-search-box>
                    <v-btn color="secondary" class="float-right mt-2" @click="searchManually(searchType)" v-if="searchType !== SearchTypeEnum.BULKUPLOAD">Search</v-btn>
                    <v-btn
                      :disabled="!historySearchResult"
                      color="secondary"
                      v-if="searchType === SearchTypeEnum.KEYWORD"
                      class="mt-2 float-right"
                      @click="showResult(historySearchResult)"
                    >View search results</v-btn>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <!-- <v-row>
                  <v-col cols="4" align="center">
                    <p class="ma-0">
                      <v-chip class="ma-0" color="red" text-color="white">{{noOfEliminated}}</v-chip>
                      <i>influencer(s) has been eliminated</i>
                    </p>
                  </v-col>
                  <v-col cols="4" align="center">
                    <p class="ma-0">
                      <v-chip class="ma-0" color="#8BC34A" text-color="white">{{noOfSelected}}</v-chip>
                      <i>influencer(s) is being selected</i>
                    </p>
                  </v-col>
                  <v-col cols="4" align="center">
                    <p class="ma-0">
                      <v-chip class="ma-0" color="primary" text-color="white">{{newPairings}}</v-chip>
                      <i>influencer(s) is ready to be sent to client</i>
                    </p>
                  </v-col>
                </v-row> -->
                <!-- <v-row>
                  <v-col cols="4" align="center">
                    <p class="ma-0">
                      <strong style="font-size:16px">({{newPairings}}) New</strong>
                    </p>
                  </v-col>
                  <v-col cols="4" align="center">
                    <p class="ma-0">
                      <strong style="font-size:16px">({{accepted}}) Accepted</strong>
                    </p>
                  </v-col>
                  <v-col cols="4" align="center">
                    <p class="ma-0">
                      <strong style="font-size:16px">({{notAccepted}}) Not Accepted</strong>
                    </p>
                  </v-col>
                </v-row> -->
                <v-row style="margin-top:15px;margin-bottom: -45px;" >
                  <v-col cols="12" sm="12" md="12" lg="7">
                    <!-- <v-row justify="center" >
                      <v-col cols="12" sm="12" md="1" lg="1" align="right">
                        <label style="padding-top:10px;">
                          Filters:
                        </label>
                      </v-col>
                      <v-col cols="12" sm="12" md="2" lg="2" >
                        <v-select
                          v-model="searchGender"
                          :items="genderItems"
                          label="Gender"
                          @change="genderOnChangeHandler"
                          dense
                          solo
                          attach
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="1" lg="1" >
                        <v-select
                          v-model="searchAge"
                          :items="ageItems"
                          label="Age Group"
                          @change="ageOnChangeHandler"
                          dense
                          solo
                          attach
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="2" lg="2" >
                        <v-select
                          v-model="searchLocation"
                          :items="locationItems"
                          label="Location"
                          @change="countryOnChangeHandler"
                          dense
                          solo
                          attach
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="2" lg="2" >
                        <v-select
                          v-model="searchAudCrediblity"
                          :items="audCrediblityFilters"
                          item-text="name"
                          label="Audience Cred."
                          @change="pairingStatusOnChangeHandler"
                          dense
                          solo
                          attach
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="2" lg="2" >
                        <v-select
                          v-model="searchPairingStatus"
                          :items="filterPairingStatusOptions"
                          item-value="status"
                          item-text="display"
                          label="Pairing Status"
                          @change="pairingStatusOnChangeHandler"
                          dense
                          solo
                          attach
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="1" lg="1" >
                        <v-btn @click="clearFilter">Clear</v-btn>
                      </v-col>
                      <v-col cols="12" sm="12" md="1" lg="1" align="right" v-if="this.campaign.pairingDisplayStatus">
                        <v-menu
                          :close-on-content-click="false"
                          bottom
                          left
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="secondary"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item v-for="(field, index) in showHideFields" :key="index">
                              <v-checkbox
                                v-model="campaign.pairingDisplayStatus[field.name]"
                                :label="field.label"
                                color="secondary"
                                :true-value="true"
                                :false-value="false"
                                hide-details
                                @change="updatePairingDisplayStatus"
                              ></v-checkbox>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row> -->
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col class="mt-3" cols="12" sm="7" md="7" lg="7">
                    <div>
                      <v-col cols="12" sm="12" md="12" lg="5">
                        <download-excel
                          v-if="items && items.length > 0"
                          class="btn btn-default"
                          :data="items"
                          :fields="json_fields"
                          worksheet="Creators"
                          name="creator_lists.xls"
                        >Download Excel</download-excel>
                        <v-btn color="error" v-if="actionSelected.length>0 && !disableLockedCOGS" @click="confirmDelete" small><v-icon small>delete</v-icon> Delete</v-btn>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="5" md="5" lg="5">
                    <v-text-field
                      v-model="searchFilter"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      item-key="dataTableKey"
                      :search="searchFilter"
                      :items-per-page="20"
                      :no-data-text="'Empty list'"
                      class="elevation-1 page__table"
                      show-select
                      :single-select="false"
                      v-model="selectAllStatus"
                      @toggle-select-all="selectAllPairings"
                    >
                      <template v-slot:body="props">
                        <tr
                          v-for="(item, parentIndex) in props.items"
                          :key="item.instagram"
                          v-bind:class="{'danger': !item.success && !item.isLoading}"
                        >
                          <td style="min-width:100px;padding: 0 14px!important;">
                            <v-checkbox
                              class="multi-select-checkbox"
                              style="padding-left:20px"
                              label=""
                              color="grey darken-2"
                              v-model="item.isDelete"
                              @change="actionSelectChange"
                            ></v-checkbox>
                          </td>
                          <td style="min-width:200px;max-width:200px" align="center" v-if="displayFields('influencer')">
                            <!-- <a
                              :href="'https://www.tiktok.com/@' + item.userHandle"
                              target="_blank"
                              v-if="item.platform === 'tiktok'"
                            ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.userHandle}}</a>
                            <a
                              :href="'https://www.instagram.com/' + item.userHandle"
                              target="_blank"
                              v-else
                            ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.userHandle}}</a> -->
                            <social-handle
                              divClassName="d-inline"
                              :isTikTok="item.platform === 'tiktok'"
                              :isInstagram="item.platform === 'instagram'"
                              :isFacebook="item.platform === 'facebook'"
                              :isYoutube="item.platform === 'youtube'"
                              :isXiaohongshu="item.platform === 'xiaohongshu'"
                              :tiktokHandle="item.userHandle"
                              :instagramHandle="item.userHandle"
                              :facebookHandle="item.userHandle"
                              :youtubeHandle="item.userHandle"
                              :xiaohongshuHandle="item.xhsID"
                              :xiaohongshuFullName="item.fullName"
                              :youtubeURL="item.url"
                            />
                            <v-menu
                              bottom
                              origin="center center"
                              transition="scale-transition"
                              v-if="item.multipleInfs && item.multipleInfs.length > 1"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  dark
                                  text
                                  v-bind="attrs"
                                  v-on="on"
                                  style="min-width:0;padding:0;margin-left:-9px;margin-top:-3px;"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon class="ml-2" color="warning" v-on="on" small>mdi-chevron-down-circle</v-icon>
                                    </template>
                                    <span>Multiple Accounts detected</span>
                                  </v-tooltip>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="(obj, i) in item.multipleInfs"
                                  :key="i"
                                  link
                                  @click="changePlatform(obj, i)"
                                >
                                  <v-list-item-title>
                                    <!-- <v-avatar size="35" color="grey lighten-4">
                                      <img
                                        class="elevation-6"
                                        v-bind:src="paserImageUrl(obj.picture)"
                                        alt="avatar"
                                      >
                                    </v-avatar> -->
                                    <a
                                      v-if="obj.xhs"
                                    ><img src="/static/img/xhs-black.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.facebook"
                                    ><v-icon color="#000000" small>mdi-facebook</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.tiktok"
                                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{obj.handle}}</a>
                                    <a
                                      v-else-if="obj.youtube"
                                    ><v-icon>mdi-youtube</v-icon> @{{obj.handle}}</a>
                                    <a
                                      v-else
                                    ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{obj.handle}}</a>
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                            <v-tooltip v-if="!item.isLoading && item.influencerID" bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon @click="true" color="green" v-on="on">done</v-icon>
                              </template>
                              <span>Registered on IMS</span>
                            </v-tooltip>
                            <v-tooltip v-if=" !item.isLoading && !item.influencerID" bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon @click="true" color="red" v-on="on">cancel</v-icon>
                              </template>
                              <span>Not in IMS</span>
                            </v-tooltip>
                            <p class="text-danger mb-0" v-if="item.socialDataErrMessage">({{item.socialDataErrMessage}})</p>
                          </td>
                          <td align="center" style="min-width:200px" @click="openEditItem(item.pairingID, 'remark')" v-if="item.remarkEdit === false && displayFields('remark')">
                            <!-- <p v-html="item.remarks"></p> -->
                            <v-tooltip bottom max-width="300px">
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <p class="remark-text">{{item.remarks || '-'}}</p>
                                </div>
                              </template>
                              <span v-html="renderRemark(item.remarks)"></span>
                            </v-tooltip>
                          </td>
                          <td align="center" class="editing" v-if="item.remarkEdit === true">
                            <v-textarea
                              class="ma-3"
                              hide-details
                              v-model="item.remarks"
                              dense
                              outlined
                              style="width:100%"
                            ></v-textarea>
                          </td>
                          <td align="center" v-if="displayFields('gender')">
                            <div v-if="!item.genderEdit">
                              <v-chip
                                class="ma-2"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                                v-if="!item.genderEdit"
                              >{{item.gender || '-'}}</v-chip>
                              <!-- <v-btn color="warning" text x-small @click="changePairingColEdit('genderEdit', item, true)" v-if="!item.genderEdit">
                                <v-icon class="cursor-pointer" color="warning" title="Update" x-small>edit</v-icon>
                              </v-btn> -->
                            </div>
                          </td>
                          <td align="center" v-if="displayFields('ageGroup')">
                            <div v-if="!item.ageGroupEdit">
                              <v-chip
                                class="ma-2"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                              >{{item.age_group || '-'}}</v-chip>
                              <!-- <v-btn color="warning" text x-small @click="changePairingColEdit('ageGroupEdit', item, true)" v-if="!item.ageGroupEdit">
                                <v-icon class="cursor-pointer" color="warning" title="Update" x-small>edit</v-icon>
                              </v-btn> -->
                            </div>
                          </td>
                          <td align="center" v-if="displayFields('audAgeGroup')">
                            <div>
                              <!-- <div class="d-flex flex-row" v-if="item.audAgesEdit">
                                <v-select
                                  style="min-width:120px;max-width:320px"
                                  :items="ageGroups"
                                  item-text="code"
                                  item-value="code"
                                  v-model="item.topAudAges"
                                  hide-details
                                  dense
                                  multiple
                                  @change="checkSelectLimit(item, 'topAudAges')"
                                ></v-select>
                                <v-btn color="success btn-edit-mth mr-1" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'topAudAges')">
                                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>check</v-icon>
                                </v-btn>
                                <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changePairingColEdit('audAgesEdit', item, false)">
                                  <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
                                </v-btn>
                              </div> -->
                              <v-chip
                                class="ma-2"
                                v-if="(!item.audAges || (Array.isArray(item.audAges) && item.audAges.length === 0))  && (!item.topAudAges || (Array.isArray(item.topAudAges) && item.topAudAges.length === 0))"
                                color="#ffffff"
                                x-small
                                text-color="black"
                                style="text-transform: capitalize;"
                              >{{'-'}}</v-chip>
                              <div v-if="Array.isArray(item.audAges) && Array.isArray(item.topAudAges)">
                                <v-menu
                                  v-if="(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"
                                  :close-on-content-click="false"
                                  top                                                 
                                  offset-x                              
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="multi-select-more-btn ma-2"
                                      :id="'btnMore_'+parentIndex"
                                      v-show="(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"  
                                      x-small
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                      text
                                    >
                                      <span v-if="item.topAudAges && item.topAudAges.length">
                                        {{item.topAudAges ? item.topAudAges[0] : '-'}}
                                      </span>
                                      <span v-else>
                                        {{item.audAges.length ? item.audAges[0].code : '-'}}
                                      </span>
                                    </v-btn>
                                  </template>
                                  <v-card max-width="300" style="text-align: left;">
                                    <v-card-text>
                                      <div>Aud. Age Group (Majority)</div>
                                      <div v-if="item.audAgesDisplay">
                                        <v-divider></v-divider>
                                        <div
                                        class="d-flex justify-space-between"
                                        v-for="(audAge, index) in item.audAgesDisplay"
                                        :key="index">                                    
                                          <v-chip
                                            class="ma-2"
                                            x-small
                                          >{{audAge.code}}</v-chip>
                                          <span class="more-percent" v-if="audAge.weight">({{(audAge.weight * 100).toFixed(2)}}%)</span>
                                        </div>
                                      </div>
                                      <v-divider></v-divider>
                                      <div
                                      class="d-flex justify-space-between"
                                      v-for="(age, index) in item.audAges"
                                      :key="index">                                    
                                        <v-chip
                                          class="ma-2"
                                          x-small           
                                        >{{age.code}}</v-chip>
                                        <span class="more-percent">({{(age.weight * 100).toFixed(2)}}%)</span>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-menu>
                              </div>
                              <div v-if="!item.audAgesEdit">
                                <!-- <v-chip               
                                  class="ma-2"
                                  x-small             
                                >{{item.topAudAges ? item.topAudAges[0] : '-'}}</v-chip> -->
                                <!-- <v-btn style="margin-top:-7px" color="warning" text x-small @click="changePairingColEdit('audAgesEdit', item, true)" v-if="!item.audAgesEdit">
                                  <v-icon class="cursor-pointer" color="warning" title="Update" x-small>edit</v-icon>
                                </v-btn> -->
                              </div>
                            </div>
                          </td>
                          <td align="center" v-if="displayFields('country')">
                            <!-- <v-chip
                              class="ma-2"
                              color="#ffffff"
                              x-small
                              text-color="black"
                              style="text-transform: capitalize;"
                            >{{item.country || '-'}}</v-chip> -->
                            <div class="d-flex flex-row" v-if="item.audCountryEdit">
                              <v-select
                                style="min-width:120px;max-width:320px"
                                :items="locationItems"
                                item-text="name"
                                item-value="name"
                                v-model="item.topCountries"
                                hide-details
                                dense
                                multiple
                                @change="checkSelectLimit(item, 'topCountries')"
                              ></v-select>
                              <v-btn color="success btn-edit-mth mr-1" style="margin-top:7px;" x-small @click="updatePairingCol(item, 'topCountries')">
                                <v-icon class="cursor-pointer" color="white" title="Close" x-small>check</v-icon>
                              </v-btn>
                              <v-btn color="red btn-edit-mth" style="margin-top:7px;" x-small @click="changePairingColEdit('audCountryEdit', item, false)">
                                <v-icon class="cursor-pointer" color="white" title="Close" x-small>close</v-icon>
                              </v-btn>
                            </div>
                            <v-chip
                              class="ma-2"
                              v-if="(!item.countries || (Array.isArray(item.countries) && item.countries.length === 0)) && (!item.topCountries || (Array.isArray(item.topCountries) && item.topCountries.length === 0))"
                              color="#ffffff"
                              x-small
                              text-color="black"
                              style="text-transform: capitalize;"
                            >{{'-'}}</v-chip>
                            <div v-if="Array.isArray(item.countries) && Array.isArray(item.topCountries)">
                              <v-menu
                                v-show="(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
                                :close-on-content-click="false"
                                top                                                 
                                offset-x                              
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="multi-select-more-btn ma-2"
                                    :id="'btnMore_'+parentIndex"        
                                    v-show="(item.countries.length || item.topCountries.length) && !item.audCountryEdit"   
                                    x-small
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    text
                                  >
                                    <span v-if="item.topCountries && item.topCountries.length">
                                      {{item.topCountries ? item.topCountries[0] : '-'}}
                                    </span>
                                    <span v-else>
                                      {{item.countries.length ? item.countries[0].name : '-'}}
                                    </span>
                                  </v-btn>
                                </template>
                                <v-card max-width="300" style="text-align: left;">
                                  <v-card-text>
                                    <div>Aud. Country (Majority)</div>
                                    <div v-if="item.topCountryDisplay">
                                      <v-divider></v-divider>
                                      <div
                                      class="d-flex justify-space-between"
                                      v-for="(country, index) in item.topCountryDisplay"
                                      :key="index">                                    
                                        <v-chip
                                          class="ma-2"
                                          x-small           
                                        >{{country.name}}</v-chip>
                                        <span class="more-percent" v-if="country.weight">({{(country.weight * 100).toFixed(2)}}%)</span>
                                      </div>
                                    </div>
                                    <v-divider></v-divider>
                                    <div
                                    class="d-flex justify-space-between"
                                    v-for="(country, index) in item.countries"
                                    :key="index">                                    
                                      <v-chip
                                        class="ma-2"
                                        x-small           
                                      >{{country.name}}</v-chip>
                                      <span class="more-percent" v-if="country.weight">({{(country.weight * 100).toFixed(2)}}%)</span>
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                            </div>
                            <div v-if="!item.audCountryEdit">
                              <!-- <v-chip               
                                class="ma-2"
                                x-small             
                              >{{item.topCountries ? item.topCountries[0] : '-'}}</v-chip> -->
                              <!-- <v-btn style="margin-top:-7px" color="warning" text x-small @click="changePairingColEdit('audCountryEdit', item, true)" v-if="!item.audCountryEdit">
                                <v-icon class="cursor-pointer" color="warning" title="Update" x-small>edit</v-icon>
                              </v-btn>                    -->
                            </div>
                          </td>
                          <td align="center" v-if="displayFields('followers')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.followers ? formatNumber(item.followers) : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('genderPercentage')">
                            <div style="width:75px;">
                              <PieChart
                                :name="`genderPie${parentIndex}`"
                                :title="genderPie.title"
                                :labels="genderPie.labels"
                                :backgroundColors="genderPie.backgroundColors"
                                :items="getGenderPieData(item.audience_genders)"
                                :options="genderPie.options"
                                :width="genderPie.width"
                                :height="genderPie.height"
                                v-if="item.audience_genders && item.audience_genders.length > 0"
                              />
                            </div>
                          </td>
                          <td align="center" v-if="displayFields('audienceCred')">
                            <v-chip
                              class="ma-2"
                              x-small
                              :color="item.audience_credibility_color"
                              text-color="white"
                            >{{item.audience_credibility}}%</v-chip>
                            <span class="text-danger" v-if="item.message">({{item.message}})</span>
                          </td>
                          <td align="center" v-if="displayFields('avgLikes')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.avg_likes ? formatNumber(item.avg_likes) : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('avgComments')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.avg_comments ? formatNumber(item.avg_comments) : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('avgReelsPlays')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.avg_reels_plays ? formatNumber(item.avg_reels_plays) : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('avgViews')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.avg_views ? formatNumber(item.avg_views) : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('avgSaves')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.avg_saves ? formatNumber(item.avg_saves) : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('avgShares')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.avg_shares ? formatNumber(item.avg_shares) : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('medianEngagementRate')">
                            <v-chip
                              class="ma-2"
                              color="#CFD8DC"
                              x-small
                              text-color="black"
                            >{{item.median_engagement_rate ? `${item.median_engagement_rate}%` : '-'}}</v-chip>
                          </td>
                          <td align="center" v-if="displayFields('infInterests')">
                            <v-chip
                              v-if="!item.infInterests || item.infInterests.length === 0"
                              class="ma-2"
                              color="#ffffff"
                              x-small
                              text-color="black"
                              style="text-transform: capitalize;"
                            >{{'-'}}</v-chip>
                            <v-chip                                 
                              v-else                              
                              v-for="(interest, index) in item.infInterests"
                              :key="index"
                              v-show="index === 0"
                              class="ma-2"
                              x-small             
                            >{{interest.name}}</v-chip>                              
                            
                            <v-menu                                                            
                            v-show="item.infInterests"      
                            :close-on-content-click="false"    
                            top                                                 
                            offset-x                              
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  :id="'btnMore_'+item.id"
                                  v-show="item.infInterests && item.infInterests.length > 0"                       
                                  color="secondary"
                                  x-small
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  text
                                >
                                  More...
                                </v-btn>
                              </template>
                              <v-card max-width="300" style="text-align: left;">
                                <v-card-text>
                                  <div>Influencer Interests</div>
                                  <v-divider></v-divider>                                    
                                  <v-chip                                      
                                    v-for="(interest, index) in item.infInterests"
                                    :key="index"
                                    v-show="index !== 0"
                                    class="ma-2"
                                    small           
                                  >{{interest.name}}</v-chip>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                          </td>
                          <td align="center" v-if="displayFields('interests')">
                            <v-chip
                              v-if="!item.audience_interests || item.audience_interests.length === 0"
                              class="ma-2"
                              color="#ffffff"
                              x-small
                              text-color="black"
                              style="text-transform: capitalize;"
                            >{{'-'}}</v-chip>
                            <v-chip                                 
                              v-else                              
                              v-for="(interest, index) in item.audience_interests"
                              :key="index"
                              v-show="index === 0"
                              class="ma-2"
                              x-small             
                            >{{interest.name}}</v-chip>                              
                            
                            <v-menu                                                            
                              v-show="item.audience_interests"
                              :close-on-content-click="false"
                              top
                              offset-x
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    :id="'btnMore_'+parentIndex"
                                    v-show="item.audience_interests && item.audience_interests.length > 0"                       
                                    color="secondary"
                                    x-small
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    text
                                  >
                                    More...
                                  </v-btn>
                                </template>
                                <v-card max-width="300" style="text-align: left;">
                                  <v-card-text>
                                    <div>Audience Interests</div>
                                    <v-divider></v-divider>
                                    <div
                                    class="d-flex justify-space-between"
                                    v-for="(interest, index) in item.audience_interests"
                                    :key="index">                                    
                                      <v-chip
                                        class="ma-2"
                                        x-small           
                                      >{{interest.name}}</v-chip>
                                      <span style="more-percent">({{(interest.weight * 100).toFixed(2)}}%)</span>
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-menu>
                          </td>
                          <td align="center" v-if="displayFields('engagement')">
                            <span v-if="item.engagement_rate && item.engagement_rate !== '0.00'">{{item.engagement_rate}}%</span>
                            <span class="caption" v-else-if="item.engagement_rate === '0.00'">
                              <v-icon small data-toggle="tooltip" data-placement="top" title="Hidden">mdi-eye-off</v-icon>
                            </span>
                            <span v-else>-</span>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row class="ma-2 text-right">
                  <v-col cols="12">
                    <v-btn
                      style="margin-right:5px"
                      color="warning"
                      target="_blank"
                      @click="invokeSaveInfData"
                    >Save</v-btn>
                    <v-btn @click="close()">Cancel</v-btn>
                  </v-col>
                </v-row>
              </v-layout>
              <loading
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="true"
                loader="bars"
                background-color="#000"
                color="secondary"
                width.number="90"
                height.number="90"
              />
            </v-container>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <influencer-list-modal
      v-model="showInfluencerSearchResult"
      :value1="showInfluencerSearchResult"
      :result="influencerSearchResult"
      :influencers="selected"
      :keyword="currentKeywordSearch"
      @input1="input1"
      @select="select"
    ></influencer-list-modal>
    <!-- Reason dialog -->
    <v-dialog v-model="reasonDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Reason for elimination</v-card-title>
        <v-card-text>{{eliminationReason}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="reasonDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Reason dialog -->
    <k-toast :variant="toast.variant" :header="toast.header" :content="toast.content"></k-toast>
    <settings-for-ai-modal
      v-model="settingAIDialog"
      :value="settingAIDialog"
      @paramsUpdated="paramsUpdated()"
    />
    <!-- Update pairing dialog -->
    <settings-for-pairing
      v-model="updatePairingDialog"
      :value="updatePairingDialog"
      :view-only="viewOnly"
      :data="activePairingData"
      @pairChanged="pairChanged()"
    />
    <!-- Update pairing dialog -->
    <!-- Price1 Price2 Multiplier Dialog -->
    <price-multiplier-modal
      v-model="priceMultiplierDialog"
      :value="priceMultiplierDialog"
      :pairedInfluencer="priceMultiplierInfluencerData"
      :campaignData="campaign"
      :multiple="isMultipleDeliverables"
      :multipleInfs="actionSelected"
      @clearSelected="clearActionSelected()"
      @savedFromPriceMultplier="pairChanged()"
    />
    <!-- Price1 Price2 Multiplier Dialog -->
    <!-- Full Screen Progress Loading Dialog -->
    <full-screen-progress
    :show="bulkProgress.show"
    isStatus="true"
    :processing="bulkProgress.processing"
    :complete="bulkProgress.complete"
    :color="secondary" />
    <!-- Full Screen Progress Loading Dialog -->
    <!-- get approval dialog -->
      <!-- <get-approval-modal
        v-model="getApprovalDialog"
        :value="getApprovalDialog"
        :pairing="approvalPairing"
        @saved="savedGetApproval"
      /> -->
    <!-- end of get approval dialog -->
    
    <!-- req cogs approval modal -->
      <req-cogs-approval-modal
        v-model="reqApprovalDialog"
        :value="reqApprovalDialog"
        :pairing="payoutEditPairing"
        :amount="reqAmt"
        :reasons="reqReasons"
        :budget="budget"
        :currentCOGS="measurement.budget"
        :cogsPercent="measurement.cogsPercentage"
        @saved="getPairedInfluencers(campaign.id)"
      />
    <!-- end of req cogs approval modal -->

    <!-- payout update table -->
      <payout-update-modal 
        v-model="editPayoutDialog"
        :value="editPayoutDialog"
        :pairing="payoutEditPairing"
        :lockedPayout="lockedPayout"
        :cappedCOGS="budget"
        :currentCOGS="measurement.budget"
        @budgetExceeded="openReqApprovalDialog"
        @refreshPairing="getPairedInfluencers(campaign.id)"
      />
    <!-- end of payout update table -->
    
    <!-- pairing elimiation edit modal -->
    <pairing-elimination-edit-modal
    v-model="eliminationDialog"
    :campaingData="campaingDataForElimination"
    @invokeSendToClient="invokeSendToClient"/>
    <!-- end of pairing elimionti... -->
  </v-layout>
</template>

<script>
import moment from 'moment';
import campaignAPIs from '../../campaignAPIs';
import campaignHelper from '../../campaignHelper'
import utils from '@/utils';
// import campaignConfig from '../config';
import influencerList from '../../../Influencer/InfluencerDataTable.vue';
import pairingInfluencersTable from '../../../Pairing/PairingDataTable.vue';
import influencerAPIs from '../../../Influencer/influencerAPIs';
import InfluencerListModal from '../InfluencerListModal';
import pairingAPIs from '../../../Pairing/pairingAPIs';
import Loading from 'vue-loading-overlay';
import KToast from '@/components/scoped/custom/KToast';
import FullScreenProgress from '@/components/scoped/custom/FullScreenProgress';
import KInfluencerSearchBox from '@/components/scoped/influencer/InfluencerSearchBox'
import 'vue-loading-overlay/dist/vue-loading.css';
import config from '../../config';
import globalConfig from '@/config';
import SocialHandle from '@/components/scoped/custom/SocialHandle'
import draggable from 'vuedraggable';
import PieChart from '@/components/chartjs/Pie';
// import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';

import { mapGetters, mapState } from 'vuex'

const SearchTypeEnum = Object.freeze({ KEYWORD: 'keyword', HANDLE: 'handle', BULKUPLOAD: 'bulkupload' });
const Steps = Object.freeze({ FIND_INFLUENCERS: 1, REVIEW: 2, ELIMINATION: 3 });
export default {
  name: 'ViewPairingModal',
  props: {
    value: Boolean,
    creator: Object
  },
  components: {
    influencerList,
    pairingInfluencersTable,
    Loading,
    InfluencerListModal,
    KInfluencerSearchBox,
    KToast,
    FullScreenProgress,
    draggable,
    PieChart,
    SocialHandle
  },
  data() {
    return {
      toast: {
        variant: '',
        content: '',
        header: ''
      },
      fromAI: {
        // Default setting
        force: false,
        page: 0
      },
      loadingAI: false,
      bulkProgress: {
        loading: true,
        processing: 0,
        complete: 0
      },
      showEditDialog: false,
      reasonDialog: false,
      settingAIDialog: false,
      // getApprovalDialog: false,
      lockedPayout: false,
      reqApprovalDialog: false,
      editPayoutDialog: false,
      eliminationDialog: false,
      campaingDataForElimination: {},
      // approvalPairing: {},
      reqApprovalPairing: {},
      payoutEditPairing: {},
      reqAmt: '',
      reqReasons: '',
      eliminationReason: '',
      // pairingStatusDisplay: config.pairingStatusDisplay,
      eliminationStatus: config.eliminationStatus,
      payoutStatus: config.payoutStatus,
      genders: [
        'Male',
        'Female'
      ],
      ageGroups: [
        '18-24',
        '25-34',
        '35-44',
        '13-17',
        '45-64',
        '65-'
      ],
      actions: [
        { name: 'Delete', color: 'red', method: 'delete', icon: 'delete' },
        { name: 'Edit', color: 'primary', method: 'edit', icon: 'edit' },
        { name: 'View', color: 'primary', method: 'view', icon: 'mdi-eye' }
      ],
      headers: [
        {
          text: 'Influencer',
          align: 'center',
          sortable: false,
          value: 'userHandle',
          name: 'influencer'
        },
        { text: 'Remark', sortable: true, value: 'remarks', align: 'center', name: 'remark' },
        { text: 'Gender', sortable: false, value: 'gender', align: 'center', name: 'gender' },
        { text: 'Age Group', sortable: false, value: 'age_group', align: 'center', name: 'ageGroup' },
        { text: 'Aud. Age Group', sortable: false, value: 'aud_age_group', align: 'center', name: 'audAgeGroup' },
        { text: 'Aud. Country', sortable: false, value: 'country', align: 'center', name: 'country' },
        { text: 'Followers', align: 'center', sortable: false, value: 'followers', name: 'followers' },
        { text: 'Follower Gender', sortable: false, value: 'genderPercentage', align: 'center', name: 'genderPercentage' },
        { text: 'Audience Cred.', sortable: false, align: 'center', value: 'audience_credibility', name: 'audienceCred' },
        { text: 'Avg. Likes', sortable: false, align: 'center', value: 'avg_likes', name: 'avgLikes' },
        { text: 'Avg. Comments', sortable: false, align: 'center', value: 'avg_comments', name: 'avgComments' },
        { text: 'Avg. Reels Plays (IG)', sortable: false, align: 'center', value: 'avg_reels_plays', name: 'avgReelsPlays' },
        { text: 'Avg. Views (TT)', sortable: false, align: 'center', value: 'avg_views', name: 'avgViews' },
        { text: 'Avg. Saves (TT)', sortable: false, align: 'center', value: 'avg_saves', name: 'avgSaves' },
        { text: 'Avg. Shares (TT)', sortable: false, align: 'center', value: 'avg_shares', name: 'avgShares' },
        { text: 'Median Engagement Rate', sortable: false, align: 'center', value: 'median_engagement_rate', name: 'medianEngagementRate' },
        { text: 'Influencer interests', sortable: false, align: 'center', value: 'infInterests', name: 'infInterests' },
        { text: 'Audience interests', sortable: false, align: 'center', value: 'audience_interests', name: 'interests' },
        { text: 'Engagement', sortable: false, align: 'center', value: 'engagement_rate', name: 'engagement' }
        // { text: 'Rate Card', sortable: false, align: 'center', value: '', name: 'rateCard' },
        // { text: 'Deliverables', sortable: false, align: 'center', value: 'predictedAmount', name: 'AIPayout' },
        // { text: 'Payout', sortable: false, align: 'center', value: 'payoutAmount', name: 'payout' },
        // { text: 'Labels', sortable: true, align: 'center' },
        // { text: 'Elimination Status', sortable: false, align: 'center', value: '', name: 'eliminationStatus' },
        // { text: 'Pairing Status', sortable: false, align: 'center', value: '', name: 'pairingStatus' }
        // { text: 'Actions', sortable: false }
      ],
      json_fields: {
        'Handle': {
          callback: item => {
            if (item.platform === 'instagram') {
              return `<a href='http://instagram.com/${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'tiktok') {
              return `<a href='https://www.tiktok.com/@${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'youtube') {
              return `<a href='https://youtube.com/@${item.userHandle}'>${item.userHandle}</a>`
            }
            if (item.platform === 'xiaohongshu') {
              return `<a href='https://xiaohongshu.com/user/profile/${item.xhsID}'>${item.userHandle}</a>`
            }
            if (item.platform === 'facebook') {
              return `<a href='https://facebook.com/@${item.userHandle}'>${item.userHandle}</a>`
            }
          }
        },
        Platform: 'platform',
        Remark: 'remarks',
        Gender: 'gender',
        'Age Group': 'age_group',
        'Aud. Age Group': 'displayAudAge',
        'Aud. Country': 'displaytopCountry',
        Followers: 'followers',
        'Follower Gender': 'audGenderDisplay',
        'Audience Cred.': 'audience_credibility',
        'Avg. Likes': 'avg_likes',
        'Avg. Comments': 'avg_comments',
        'Avg. Reels Plays (IG)': 'avg_reels_plays',
        'Avg. Views (TT)': 'avg_views',
        'Avg. Saves (TT)': 'avg_saves',
        'Avg. Shares (TT)': 'avg_shares',
        'Median Engagement Rate': 'medianEngRateDisplay',
        'Influencer Interests': 'infInterestDisplay',
        'Aud. Interests': 'audInterestDisplay',
        Engagement: 'engagementRateDisplay',
        'TikTok Posts': 'no_of_tiktok_posts',
        'Posts': 'no_of_posts',
        'Carousels': 'no_of_carousels',
        Videos: 'no_of_video',
        Stories: 'no_of_stories',
        Reels: 'no_of_reels',
        Youtube: 'youtube',
        XHS: 'no_of_xhs_posts',
        Facebook: 'no_of_fb_posts',
        Remarks: 'remarks'
      },
      showHideFields: [
        {
          name: 'influencer',
          label: 'Influencer'
        },
        {
          name: 'remark',
          label: 'Remarks'
        },
        {
          name: 'gender',
          label: 'Gender'
        },
        {
          name: 'ageGroup',
          label: 'Age Group'
        },
        {
          name: 'audAgeGroup',
          label: 'Aud. Age Group'
        },
        {
          name: 'country',
          label: 'Aud. Country'
        },
        {
          name: 'followers',
          label: 'Followers'
        },
        {
          name: 'genderPercentage',
          label: 'Follower Gender'
        },
        {
          name: 'audienceCred',
          label: 'Audience Cred.'
        },
        {
          name: 'avgLikes',
          label: 'Avg. Likes'
        },
        {
          name: 'avgComments',
          label: 'Avg. Comments'
        },
        {
          name: 'avgReelsPlays',
          label: 'Avg. Reels Plays (IG)'
        },
        {
          name: 'avgViews',
          label: 'Avg. Views (TT)'
        },
        {
          name: 'avgSaves',
          label: 'Avg. Saves (TT)'
        },
        {
          name: 'avgShares',
          label: 'Avg. Shares (TT)'
        },
        {
          name: 'medianEngagementRate',
          label: 'Median Engagement Rate'
        },
        {
          name: 'infInterests',
          label: 'Influencer interests'
        },
        {
          name: 'interests',
          label: 'Audience interests'
        },
        {
          name: 'engagement',
          label: 'Engagement'
        },
        {
          name: 'rateCard',
          label: 'Rate Card'
        },
        {
          name: 'AIPayout',
          label: 'Deliverables'
        },
        {
          name: 'payout',
          label: 'Payout'
        },
        {
          name: 'eliminationStatus',
          label: 'Elimination Status'
        },
        {
          name: 'pairingStatus',
          label: 'Pairing Status'
        }
      ],
      defaultPairingDisplayStatus: {
        influencer: true,
        remark: true,
        gender: true,
        genderPercentage: true,
        ageGroup: true,
        audAgeGroup: true,
        country: true,
        followers: true,
        audienceCred: true,
        avgLikes: true,
        avgComments: true,
        avgViews: true,
        avgReelsPlays: true,
        medianEngagementRate: true,
        infInterests: true,
        interests: true,
        engagement: true,
        rateCard: true,
        AIPayout: true,
        payout: true,
        eliminationStatus: true,
        pairingStatus: true
      },
      items: [],
      pairedInfluencers: [], // List influencers have been sent to client for elimination
      listReview: [], // For review only
      suggestedInfluencers: [],
      isLoading: false,
      campaign: {},
      searchKeywordAction: '',
      SearchTypeEnum,
      Steps,
      igHandle: '',
      viewOnly: false,
      searchType: SearchTypeEnum.HANDLE,
      actionSelected: [],
      selected: [],
      measurement: {
        total: 0,
        outreach: 0,
        engagement: 0,
        budget: 0,
        outreachPercentage: 0,
        engagementPercentage: 0,
        cogsPercentage: 0
      },
      historySearchResult: null,
      currentKeywordSearch: '', // For intuitive UI
      pairingStepper: Steps.FIND_INFLUENCERS,
      showInfluencerSearchResult: false,
      influencerSearchResult: null,
      activePairingData: null,
      updatePairingDialog: false,
      priceMultiplierDialog: false,
      priceMultiplierInfluencerData: null,
      lineUpItems: [],
      genderItems: ['Male', 'Female'],
      genderPie: {
        title: 'Report Abuse in %',
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center'
          }
        },
        width: 50,
        height: 50
      },
      searchInfluencerTypes: ['Instagram', 'TikTok', 'Youtube'],
      filteredItems: [],
      ageItems: [],
      locationItems: [],
      searchGender: '',
      searchAge: '',
      searchLocation: '',
      searchPairingStatus: '',
      searchAudCrediblity: '',
      searchInfluencer: 'Instagram',
      topFiveAudienceInterests: [],
      disableSaveLineUp: true,
      disableSaveEdit: true,
      isOpen: '',
      openExpansion: [],
      inputRates: {},
      rateCardFormRates: {},
      isPricingDeskEmpty: false,
      isEditing: false,
      searchFilter: '',
      audCrediblityFilters: [
        {name: 'Red', min: 0, max: 30},
        {name: 'Orange', min: 30, max: 50},
        {name: 'Green', min: 50, max: 100}
      ],
      markupCOGSAmount: false,
      campaignHelper,
      oldEditItem: null,
      isMultipleDeliverables: false,
      infListTitle: 'Untitled'
    };
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    ...mapState({
      rateCards: state => state.influencer.rateCards,
      requestedPayoutEdit: state => state.pairing.requestedPayoutEdit,
      campaignUpdated: state => state.campaign.campaignUpdated,
      infDetail: state => state.influencer.infDetail
    }),
    filteredHeaders() {
      return this.headers.filter(h => {
        let pairingDisplayStatus = this.campaign.pairingDisplayStatus
        if (pairingDisplayStatus !== undefined) {
          if (h.name !== undefined && !pairingDisplayStatus[h.name]) {
            return false
          }
        }
        return true
      })
    },
    selectAllStatus() {
      return utils.func.refreshJSON(this.actionSelected)
    },
    showBtnCO: function() {
      if (Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === globalConfig.userRoles.AD_STRATEGIST) {
        return true;
      } else {
        return false
      }
    },
    showBtnAM: function() {
      if (Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW) {
        return true;
      } else if (Number(this.$store.state.user.role) === globalConfig.userRoles.ACCOUNT_MANAGER) {
        return true;
      } else {
        return false
      }
    },
    isSuperAdmin: function() {
      return Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH
    },
    isAdmin: function() {
      return Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH || Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW
    },
    pairingStatusOptions: function() {
      // let data = [];
      // Object.entries(config.pairingStatus).forEach(item => {
      //   data.push({
      //     status: item[1],
      //     display: config.pairingStatusDisplay[item[1]]
      //   });
      // });
      // return data;
      let data = [];
      Object.entries(this.pairingStatus).forEach(item => {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    },
    acceptPairingStatusOptions: function() {
      let data = [];
      Object.entries(this.pairingStatus).forEach(item => {
        if (item[1].value === config.pairingStatus.ACCEPTED || item[1].value === config.pairingStatus.NOT_ACCEPTED) {
          data.push({
            status: item[1].value,
            display: item[1].text
          });
        }
      });
      return data;
    },
    filterPairingStatusOptions: function() {
      let data = [];
      Object.entries(this.pairingStatus).forEach(item => {
        if (item[1].value === config.pairingStatus.NEW || item[1].value === config.pairingStatus.ACCEPTED || item[1].value === config.pairingStatus.NOT_ACCEPTED) {
          data.push({
            status: item[1].value,
            display: item[1].text
          });
        }
      });
      data.unshift({
        status: '',
        display: 'All'
      });
      return data;
    },
    budget: function() {
      this.markupCOGSAmount = campaignHelper.getMarkupCOGS(this.campaign.ioNumbers, this.client)
      return this.markupCOGSAmount ? this.markupCOGSAmount : Math.floor(this.campaign.budget * 0.26)
    },
    newPairings: function() {
      return this.items.filter(item => item.pairingStatus === this.pairingStatus.NEW.value).length;
    },
    accepted: function() {
      return this.items.filter(item => item.pairingStatus === this.pairingStatus.ACCEPTED.value).length;
    },
    notAccepted: function() {
      return this.items.filter(item => item.pairingStatus === this.pairingStatus.NOT_ACCEPTED.value).length;
    },
    newEliminations: function() {
      return this.items.filter(item => item.eliminationStatus === this.eliminationStatus.NEW).length;
    },
    noOfSelected: function() {
      return this.items.filter(item => item.eliminationStatus === this.eliminationStatus.SELECTED).length;
    },
    noOfEliminated: function() {
      return this.items.filter(item => item.eliminationStatus === this.eliminationStatus.ELIMINATED).length;
    },
    disableLockedCOGS: function() {
      return this.campaign.lockedCOGS || false
    },
    showLockBtn() {
      if (this.campaign.id && !this.campaign.lockedCOGS &&
      (Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_HIGH ||
      Number(this.$store.state.user.role) === globalConfig.userRoles.SUPER_ADMIN_LOW ||
      Number(this.$store.state.user.role) === globalConfig.userRoles.AD_STRATEGIST)) {
        return true
      }
      return false
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.resetData()
        if (this.creator) {
          this.infListTitle = this.creator.name
          for (let creator of this.creator.creators) {
            creator = this.beautifyData(creator)
            creator.success = true
            this.items.push(creator)
          }
        }
      }
    }
  },
  mounted: async function() {
    // implement
    this.resetData()
  },
  methods: {
    getPairingStatusLabels(status) {
      let lable;
      Object.entries(this.pairingStatus).forEach(item => {
        if (item[1].value === status) {
          lable = item[1].text;
        }
      });
      return lable;
    },
    priceMultiplierHandler(item) {
      this.priceMultiplierInfluencerData = item;
      this.isMultipleDeliverables = false;
      this.priceMultiplierDialog = true;
    },
    calculateOutreach(item) {
      const followers = item.followers;
      return followers * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateEngagement(item) {
      const engagements = item.engagements;
      return engagements * (item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts);
    },
    calculateContents(item) {
      return item.no_of_tiktok_posts + item.no_of_posts + item.no_of_video + item.no_of_stories + item.no_of_carousels + item.no_of_reels + item.no_of_xhs_posts;
    },
    pairChanged() {
      this.updatePairingDialog = false;
      this.priceMultiplierDialog = false;
      this.getPairedInfluencers(this.campaign.id);
    },
    openDeliverableUpdateDialog() {
      this.isMultipleDeliverables = true
      this.priceMultiplierDialog = true;
    },
    updatePairingStatusHandler(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = false; // For editing
    },
    viewDetailPairing(pairedInfluencer) {
      this.activePairingData = pairedInfluencer;
      this.updatePairingDialog = true;
      this.viewOnly = true; // For view only
    },
    executeMethod(method, data) {
      switch (method) {
        case 'delete':
          this.removeSelectedInfluencer(data.userHandle, data.platform);
          break;
        case 'view':
          this.viewDetailPairing(data);
          break;
        case 'edit':
          this.updatePairingStatusHandler(data);
          break;
        case 'refresh':
          this.refreshPairingData(data);
          break;
      }
    },
    refreshPairingData(data) {
      this.isLoading = true
      this.refreshInfluencerDetail(data.userHandle, data.platform.toLowerCase(), data.pairingID);
      this.addToSelectedInfluencers(data.userHandle, data.platform.toLowerCase());
    },
    paramsUpdated() {
      this.settingAIDialog = false;
      this.getSuggestedInfluencerFromAI(this.campaign.id, true);
    },
    enableSettingForAI() {
      this.settingAIDialog = !this.settingAIDialog;
    },
    showReason(text) {
      this.eliminationReason = text;
      this.reasonDialog = true;
    },
    editAmount(item) {
      let index = this.items.findIndex(element => element.userHandle === item.userHandle);
      if (index === -1) return; // The item is not present in the list
      this.items[index].isEditting = true;
      this.items.splice();
    },
    // Finish updating payout amount
    // onEnter(item) {
    //   let index = this.items.findIndex(element => element.userHandle === item.userHandle);
    //   if (index === -1) return; // The item is not present in the list
    //   this.items[index].isEditting = false;
    //   this.items.splice();
    //   let payload = {
    //     pairingID: item.pairingID,
    //     payoutAmount: item.payoutAmount
    //   };
    //   pairingAPIs.updatePayoutAmount(payload).then(() => {
    //     if (this.isBudgetOver(this.budget, this.measurement.budget)) {
    //       this.makeToast({
    //         content: 'The current budget for this campaign is exceeded the limited.',
    //         header: 'Warning!',
    //         variant: 'danger'
    //       });
    //     }
    //   });
    // },
    // makeToast(toast) {
    //   this.toast = toast;
    //   this.$bvToast.show('kobe-toast');
    // },
    isSelected(igHandle, platform) {
      return this.selected.find(e => e.handle === igHandle && e.platform === platform);
    },
    async updateLineUp() {
      await this.lineUpItems.map((item, index) => {
        let data = {
          pairingID: item.pairingID,
          lineUpIndex: index
        }
        pairingAPIs.updateLineUpIndex(data)
      })
    },
    invokeSendToAM() {
      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.isLoading = true;
              pairingAPIs
              .sendCOGSExceedReminder(this.campaign.id)
              .then(sents => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: `The request for release has been sent to Admin.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
            }
          })
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.sendToAM()
            }
          })
        }
        return
      } else {
        this.sendToAM()
      }
    },
    sendToAM() {
      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: `${this.newEliminations} new influencer(s) will be sent to AM for approval.`
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          if (this.lineUpItems.length > 0) {
            this.updateLineUp()
            pairingAPIs
              .sendListInfluencersToAM(this.campaign.id)
              .then(() => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  showCancelButton: true,
                  text: `The list has been sent to client.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            pairingAPIs
              .sendListInfluencersToAM(this.campaign.id)
              .then(() => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  showCancelButton: true,
                  text: `The list has been sent to AM.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        }
      });
    },
    showPairingEliminEditModal() {
      this.eliminationDialog = true
      this.campaingDataForElimination = Object.assign({}, this.campaign)
    },
    invokeSendToClient() {
      if (this.isBudgetOver(this.budget, this.measurement.budget)) {
        if (!this.isSuperAdmin) {
          this.$swal({
            title: 'Are you sure?',
            icon: 'warning',
            confirmButtonText: 'Request for release',
            showCancelButton: true,
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.isLoading = true;
              pairingAPIs
              .sendCOGSExceedReminder(this.campaign.id)
              .then(sents => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  text: `The request for release has been sent to Admin.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
            }
          })
        }
        if (this.isSuperAdmin) {
          this.$swal({
            title: 'Warning',
            icon: 'warning',
            text: `The current budget for this campaign is exceeded the limited. Please check again`
          }).then(result => {
            if (result.value) {
              this.sendToClient()
            }
          })
        }
        return;
      } else {
        this.sendToClient()
      }
    },
    sendToClient() {
      this.$swal({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        text: `${this.newEliminations} new influencer(s) will be sent to client for elimination.`
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          if (this.lineUpItems.length > 0) {
            this.updateLineUp()
            pairingAPIs
              .sendListInfluencersToClient(this.campaign.id)
              .then(sents => {
                this.isLoading = false;
                this.$swal({
                  title: 'Success',
                  icon: 'info',
                  showCancelButton: true,
                  text: `The list has been sent to client.`
                });
                this.getPairedInfluencers(this.campaign.id);
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            pairingAPIs
            .sendListInfluencersToClient(this.campaign.id)
            .then(sents => {
              this.isLoading = false;
              this.$swal({
                title: 'Success',
                icon: 'info',
                showCancelButton: true,
                text: `The list has been sent to client.`
              });
              this.getPairedInfluencers(this.campaign.id);
            })
            .catch(() => {
              this.isLoading = false;
            });
          }
        }
      });
    },
    close() {
      this.saveInfData(true)
      this.$emit('input');
    },
    // For controlling sub modal
    input1() {
      this.showInfluencerSearchResult = false;
    },
    select(userHandle, platform) {
      if (this.selected.find(e => e.handle === userHandle && e.platform === platform.toLowerCase())) {
        // this.removeSelectedInfluencer(userHandle);
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'Influencer is being selected'
        });
      } else {
        if (platform === 'Instagram') {
          userHandle = userHandle ? utils.func.espaceHandleSign(utils.func.regexMatchIg(userHandle, globalConfig.regexPattern.instagram_profile)) : ''
        } else if (platform === 'TikTok') {
          userHandle = userHandle ? utils.func.espaceHandleSign(utils.func.extractTikTokHandle(userHandle)) : ''
        }
        this.crawlInfluencerDetail(userHandle, this.searchInfluencer);
        this.addToSelectedInfluencers(userHandle, platform.toLowerCase());
      }
    },
    async removeSelectedInfluencer(userHandle, platform) {
      let item = this.items.find(element => element.userHandle === userHandle && element.platform === platform);
      utils.func.removePairingElementFromArray(this.items, userHandle, 'object', 'userHandle', platform);
      utils.func.removePairingElementFromArray(this.selected, userHandle, 'string', 'handle', platform);
      utils.func.removeElementFromArray(this.ageItems, this.items.country, 'object', 'country')
      if (this.creator) {
        if (this.creator.id) {
          if (item.pairingID) {
            let payload = {
              creatorId: item.pairingID
            }
            if (this.creator) {
              payload.creatorListId = this.creator.id
            }
            await this.$store.dispatch('pairing/deleteInfDetailData', payload)
          }
        }
      }
      // Nyein - commented out old delete check
      // let text = "You won't be able to revert this!";
      // let item = this.items.find(element => element.userHandle === userHandle && element.platform === platform);
      // if (item.eliminationStatus === this.eliminationStatus.SELECTED) {
      //   text = 'This influencer is being selected by client. Do you still want to delete it?';
      // }
      // this.$swal({
      //   title: 'Are you sure?',
      //   icon: 'warning',
      //   showCancelButton: true,
      //   text
      // }).then(result => {
      //   if (result.value) {
      //     utils.func.removePairingElementFromArray(this.items, userHandle, 'object', 'userHandle', platform);
      //     utils.func.removePairingElementFromArray(this.selected, userHandle, 'string', 'handle', platform);
      //     utils.func.removeElementFromArray(this.ageItems, this.items.country, 'object', 'country')
      //     if (item.pairingID) {
      //       pairingAPIs.removePairing(item.pairingID).then(() => {
      //         console.log('removed', item);
      //       });
      //     }
      //   } else {
      //     this.selected.splice(); // Undo the unselect action, it will fire the event in 'InfluencerListModal'
      //   }
      // });
    },

    addToSelectedInfluencers(userHandle, platform) {
      let inf = {
        userHandle: userHandle,
        remarks: '',
        pairingStatus: '',
        eliminationStatus: '',
        gender: '',
        age_group: '',
        followers: '0',
        country: '',
        audience_interests: [],
        audience_credibility: '0',
        engagements: 0,
        engagement_rate: '0',
        payoutAmount: '0',
        isLoading: true,
        platform
      };
      utils.func.pushPairingElementToArray(this.items, inf, 'userHandle', 'object', platform);
      utils.func.pushPairingElementToArray(this.selected, {handle: userHandle, platform}, 'handle', 'object', platform);
    },

    getSuggestedInfluencerFromAI(campaignID, force) {
      this.loadingAI = true;
      pairingAPIs
        .getInfluencerFromAI(campaignID, force)
        .then(resp => {
          this.loadingAI = false;
          if (resp) {
            for (let inf of resp) {
              inf.platform = 'instagram'
              utils.func.pushElementToArray(this.suggestedInfluencers, inf, 'userHandle', utils.TYPE.OBJECT);
            }
          }
        })
        .catch(err => {
          this.loadingAI = false;
          console.error(err);
        });
    },
    refreshInfluencerDetail(ighandle, platform, pairingID) {
      pairingAPIs.refreshInfluencerDetails({ighandle, campaignID: this.campaign.id, platform: platform.toLowerCase(), pairingID}).then(response => {
        let index = this.items.findIndex(item => item.userHandle === ighandle && item.platform === platform.toLowerCase());
        let inf = this.items[index];
        if (response.success) {
          let data = response.data;
          inf = this.beautifyData(data);
        } else {
          inf.message = response.message || ''
          inf.socialDataErrMessage = response.socialDataErrMessage || ''
          inf.audience_credibility = response.audience_credibility || 0
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50'
          inf = this.initEditFields(inf)
        }
        inf.isLoading = false;
        inf.success = response.success;
        this.items[index] = inf;
        this.items = this.items.slice();
        this.setAgeGroupItems(this.items)
        this.getTopFiveAudienceInterests(this.items)
        this.setMultipleInfs()
        this.isLoading = false
      });
    },
    crawlInfluencerDetail(userHandle, platform) {
      pairingAPIs.fetchInfluencerForList({userHandle, platform: platform.toLowerCase()}).then(response => {
        let index = this.items.findIndex(item => item.userHandle === userHandle && item.platform === platform.toLowerCase());
        let inf = this.items[index];
        if (response.success) {
          let data = response.data;
          inf = this.beautifyData(data);
        } else {
          inf.message = response.message || ''
          inf.socialDataErrMessage = response.socialDataErrMessage || ''
          inf.audience_credibility = response.audience_credibility || 0
          inf.audience_credibility_color = response.audience_credibility_color || '#4caf50'
          inf = this.initEditFields(inf)
        }
        inf.isLoading = false;
        inf.success = response.success;
        this.items[index] = inf;
        this.items = this.items.slice();
        this.setAgeGroupItems(this.items)
        this.getTopFiveAudienceInterests(this.items)
        this.setMultipleInfs()
      });
    },

    beautifyData(data) {
      let inf = {};
      inf = data.influencer_details;
      inf.influencer_details = Object.assign({}, data.influencer_details);
      const deliverablesDetails = data.deliverables_details || {};
      const additionalDetails = data.additional_details || {};
      const audienceDetails = data.avg_performances || null
      inf.remarks = additionalDetails.remarks;
      inf.deliverableDetails = deliverablesDetails
      inf.no_of_tiktok_posts = deliverablesDetails.no_of_tiktok_posts || 0;
      inf.no_of_posts = deliverablesDetails.no_of_posts || 0;
      inf.no_of_carousels = deliverablesDetails.no_of_carousels || 0;
      inf.no_of_video = deliverablesDetails.no_of_video || 0;
      inf.no_of_stories = deliverablesDetails.no_of_stories || 0;
      inf.no_of_reels = deliverablesDetails.no_of_reels || 0;
      inf.no_of_fb_posts = deliverablesDetails.no_of_fb_posts || 0;
      inf.no_of_xhs_posts = deliverablesDetails.no_of_xhs_posts || 0;
      inf.loading_whitelisting = deliverablesDetails.loading_whitelisting || '';
      inf.youtube = deliverablesDetails.youtube || 0;
      inf.exclusivity = deliverablesDetails.exclusivity || '';
      inf.physical_attendance = deliverablesDetails.physical_attendance || 0;
      inf.online_attendance = deliverablesDetails.online_attendance || 0;
      inf.customDeliverables = deliverablesDetails.custom || [];
      inf.pairingID = data.id;
      inf.lineUpIndex = data.lineUpIndex;
      inf.platform = inf.platform || 'instagram'
      inf.audience_genders = inf.audience_genders || []
      inf = this.initEditFields(inf)
      if (!inf.userHandle) inf.userHandle = inf.instagramHandle
      if (inf.platform && inf.platform === 'xiaohongshu') {
        inf.userHandle = inf.fullName
        inf.xhsID = inf.xhsID || inf.instagramHandle
      }
      if (audienceDetails) {
        inf.avg_likes = audienceDetails.avg_likes || ''
        inf.avg_comments = audienceDetails.avg_comments || ''
        inf.avg_views = audienceDetails.avg_views || ''
        inf.avg_reels_plays = audienceDetails.avg_reels_plays || ''
        inf.avg_saves = audienceDetails.avg_saves || ''
        inf.avg_shares = audienceDetails.avg_shares || ''
        inf.median_engagement_rate = audienceDetails.median_engagement_rate || ''
      }
      inf.topAudAges = []
      if (inf.audAges) {
        inf.audAges = sortBy(inf.audAges, 'lineupIndex');
        inf.audAges = inf.audAges.map(a => {
          if (!a.lineupIndex) {
            // put large num to show as last values in sorting
            a.lineupIndex = 999
          } else if (a.lineupIndex !== 999) {
            // top is used as two selected ages
            inf.topAudAges.push(a.code)
          }
          return a
        })
        inf.audAges = inf.audAges.sort((a, b) => a.lineupIndex - b.lineupIndex)
        if (inf.topAudAges.length) {
          // display is used to display as top two in more menu
          inf.audAgesDisplay = inf.audAges.slice(0, inf.topAudAges.length)
        }
      } else {
        inf.audAges = []
      }
      // for excel export aud ages display
      if (inf.audAges && inf.audAges.length) {
        inf.displayAudAge = inf.audAges.slice(0, 3)
        if (inf.displayAudAge.length) {
          inf.displayAudAge = inf.displayAudAge.map(d => `${d.code} (${(d.weight * 100).toFixed(2)}%)`).join('\n')
        }
      }
      inf.topCountries = []
      if (inf.countries) {
        inf.countries = sortBy(inf.countries, 'lineupIndex');
        inf.countries = inf.countries.map(a => {
          if (!a.lineupIndex) {
            // put large num to show as last values in sorting
            a.lineupIndex = 999
          } else if (a.lineupIndex !== 999) {
            // top is used as two selected countries
            inf.topCountries.push(a.name)
          }
          return a
        })
        if (inf.topCountries.length) {
          // display is used to display as top two in more menu
          inf.topCountryDisplay = inf.countries.slice(0, inf.topCountries.length)
        }
      } else {
        inf.countries = []
      }
      // for excel export
      // if (inf.topCountries && inf.topCountries.length) {
      //   inf.displaytopCountry = inf.topCountries[0]
      // } else {
      //   if (inf.countries.length) {
      //     inf.displaytopCountry = inf.countries[0].name
      //   }
      // }
      if (inf.countries && inf.countries.length) {
        inf.displaytopCountry = inf.countries.slice(0, 3)
        if (inf.displaytopCountry.length) {
          inf.displaytopCountry = inf.displaytopCountry.map(d => `${d.name} (${(d.weight * 100).toFixed(2)}%)`).join('\n')
        }
      }
      // Inf Interests
      if (inf.infInterests) {
        if (inf.infInterests.length) {
          inf.infInterestDisplay = inf.infInterests.map(i => i.name).join(',')
        }
      }
      // Aud Interests
      if (inf.audience_interests) {
        if (inf.audience_interests) {
          inf.audInterestDisplay = inf.audience_interests.map(i => i.name).join(',')
        }
      }
      // Aud Genders
      let audGenderRet = []
      if (Array.isArray(inf.audience_genders)) {
        let male = inf.audience_genders.find(a => a.code === 'MALE')
        if (male) audGenderRet.push(male)
        let female = inf.audience_genders.find(a => a.code === 'FEMALE')
        if (female) audGenderRet.push(female)
        audGenderRet = audGenderRet.map(gender => `${gender.code} (${(gender.weight * 100).toFixed(2)}%)`).join('\n')
      }
      inf.audGenderDisplay = audGenderRet
      // eng rate, median eng rate
      inf.engagementRateDisplay = ''
      if (inf.engagement_rate) inf.engagementRateDisplay = `${inf.engagement_rate}%`
      inf.medianEngRateDisplay = ''
      if (inf.median_engagement_rate) inf.medianEngRateDisplay = `${inf.median_engagement_rate}%`
      inf.genderEdit = false
      inf.ageGroupEdit = false
      inf.audAgesEdit = false
      inf.audCountryEdit = false
      return inf;
    },
    async setMultipleInfs() {
      for (let item of this.items) {
        if (!item.influencerID) {
          continue
        }
        let infs = []
        await this.$store.dispatch('influencer/getInfluencerDetail', {
          id: item.influencerID
        })
        if (this.infDetail.instagram) {
          infs.push({
            handle: this.infDetail.instagram.instagramHandle,
            instagramID: this.infDetail.instagram.instagramID,
            picture: this.infDetail.audience ? this.infDetail.audience.user_profile.picture : this.infDetail.instagram.picture,
            instagram: true
          })
        }
        if (this.infDetail.tiktok) {
          infs.push({
            handle: this.infDetail.tiktok.tiktokHandle,
            tiktokID: this.infDetail.tiktok.tiktokID,
            picture: this.infDetail.tiktokaudience ? this.infDetail.tiktokaudience.user_profile.picture : this.infDetail.tiktok.picture,
            tiktok: true
          })
        }
        if (this.infDetail.youtube) {
          infs.push({
            handle: this.infDetail.youtube.youtubeHandle,
            youtubeID: this.infDetail.youtube.youtubeID,
            picture: this.infDetail.youtubeaudience ? this.infDetail.youtubeaudience.user_profile.picture : this.infDetail.youtube.picture,
            youtube: true
          })
        }
        if (this.infDetail.xiaohongshu) {
          infs.push({
            handle: this.infDetail.xiaohongshu.xhsHandle,
            xhsID: this.infDetail.xiaohongshu.xhsID,
            picture: this.infDetail.xiaohongshu ? this.infDetail.xiaohongshu.profilePicture : '',
            xhs: true
          })
        }
        if (this.infDetail.facebook) {
          infs.push({
            handle: this.infDetail.facebook.handle,
            xhsID: this.infDetail.facebook.facebookId,
            picture: this.infDetail.facebook ? this.infDetail.facebook.profilePicture : '',
            facebook: true
          })
        }
        item.multipleInfs = infs
      }
      this.items = Object.assign([], this.items)
    },
    searchManually(searchType) {
      switch (searchType) {
        case SearchTypeEnum.KEYWORD:
          this.searchByKeyword();
          break;
        case SearchTypeEnum.HANDLE:
          this.searchByHandle(this.igHandle);
          this.igHandle = ''; // Reset the search box
          break;
      }
    },
    searchByHandle(ighandle) {
      if (!ighandle || ighandle === '') {
        let errMsg = ''
        if (this.searchInfluencer === 'Instagram') {
          errMsg = 'Please enter the Instagram Handle'
        } else if (this.searchInfluencer === 'Facebook') {
          errMsg = 'Please enter the Facebook ID'
        } else if (this.searchInfluencer === 'Youtube') {
          errMsg = 'Please enter the Youtube ID'
        } else {
          errMsg = 'Please enter the TikTok Handle'
        }
        this.$swal({
          title: 'Error',
          text: errMsg,
          type: 'info'
        });
        return;
      }
      // if (ighandle.includes('https://') && this.searchInfluencer !== 'Xiaohongshu') {
      //   this.$swal({
      //     title: 'Error!',
      //     icon: 'error',
      //     showCancelButton: false,
      //     text: 'Invalid Handle'
      //   });
      //   return;
      // }
      this.select(ighandle, this.searchInfluencer);
    },
    searchByKeyword() {
      this.isLoading = true;
      this.searchKeywordAction = utils.func.makeid(5);
    },
    resultFromSearchKeyword(value) {
      this.isLoading = false;
      if (value.success) {
        this.currentKeywordSearch = value.keyword;
        this.historySearchResult = value;
        this.showResult(value);
      }
    },
    isBudgetOver(target, current) {
      return current / target > 1;
    },
    showResult(result) {
      this.showInfluencerSearchResult = true;
      this.influencerSearchResult = Object.assign({}, result);
      this.selected.splice();
    },
    getPairedInfluencers(campaignID) {
      this.isLoading = true
      pairingAPIs.getPairedInfluencersByCampaign(campaignID).then(resp => {
        this.isLoading = false
        if (resp) {
          let items = [];
          let selected = [];
          for (let data of resp) {
            let inf = this.beautifyData(data);
            inf.isLoading = false;
            inf.success = true;
            items.push(inf);
            selected.push({handle: inf.userHandle, platform: inf.platform});
          }
          let pairedInfluencer = Object.assign([], items);
          this.items = pairedInfluencer.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          this.filteredItems = this.items
          this.selected = Object.assign([], selected);
          this.setAgeGroupItems(this.items)
          this.getTopFiveAudienceInterests(this.items)
          this.checkOpenPayoutEditDialog()
          this.setMultipleInfs()
          this.handleTableUpdate(this.items)
          if (this.unlockCogs) {
            this.changeLock(this.campaign, false)
            this.$emit('setUnlockCogs', false)
          }
        }
      }).catch(error => {
        console.log(error)
        this.isLoading = false
      })
    },
    setAgeGroupItems(items) {
      let arrayItem = []
      items.map(item => {
        if (item.age_group) {
          arrayItem.push(item.age_group)
        }
      })
      this.ageItems = [...new Set(arrayItem)]
    },
    goToStep(step) {
      this.pairingStepper = step;
    },
    getAge(birthday) {
      return moment().format('YYYY') - moment(birthday).format('YYYY');
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatCurrency(number) {
      return utils.func.formatCurrency(number);
    },
    formatNumber(number) {
      return utils.func.formatNumber(number);
    },
    formatUploadedDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    handleTableUpdate(items) {
      this.lineUpItems = items
      this.updateLineUp()
      // this.disableSaveLineUp = false
    },
    actionSelectChange() {
      this.actionSelected = this.items.filter(i => i.isDelete)
    },
    clearFilter() {
      this.searchGender = ''
      this.searchAge = ''
      this.searchLocation = ''
      this.searchPairingStatus = ''
      this.searchAudCrediblity = ''
      this.getPairedInfluencers(this.campaign.id);
    },
    clearPairingData() {
      this.items = []
      this.filteredItems = []
    },
    clearActionSelected() {
      this.items = this.items.map(inf => {
        delete inf.isDelete;
        return inf
      })
      this.actionSelected = []
    },
    genderOnChangeHandler() {
      if (this.searchAge && this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.gender === this.searchGender.toString().toUpperCase())
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      } else this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase())
      this.getTopFiveAudienceInterests(this.items)
    },
    ageOnChangeHandler() {
      if (this.searchGender && this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase())
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      } else this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase())
      this.getTopFiveAudienceInterests(this.items)
    },
    countryOnChangeHandler() {
      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      } else this.items = this.filteredItems.filter(item => item.country === this.searchLocation)
      this.getTopFiveAudienceInterests(this.items)
    },
    pairingStatusOnChangeHandler() {
      this.items = utils.func.refreshJSON(this.filteredItems)
      if (this.searchAge && this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchAge) {
        this.items = this.filteredItems.filter(item => item.age_group === this.searchAge.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchGender) {
        this.items = this.filteredItems.filter(item => item.gender === this.searchGender.toString().toUpperCase() && item.country === this.searchLocation)
      } else if (this.searchLocation) {
        this.items = this.filteredItems.filter(item => item.country === this.searchLocation)
      } else if (this.searchPairingStatus || this.searchPairingStatus === config.pairingStatus.NEW) {
        this.items = this.filteredItems.filter(item => item.pairingStatus === this.searchPairingStatus)
      } else if (this.searchAudCrediblity) {
        let searchedCred = this.audCrediblityFilters.find(aud => aud.name === this.searchAudCrediblity)
        this.items = this.filteredItems.filter(item => item.audience_credibility >= searchedCred.min && item.audience_credibility < searchedCred.max)
      }
      this.getTopFiveAudienceInterests(this.items)
    },
    getCountries() {
      influencerAPIs.getCountries().then(countries => {
        this.locationItems = countries.map(item => item.name);
      });
    },
    getTopFiveAudienceInterests(items) {
      let audienceInterests = []
      this.topFiveAudienceInterests = []
      items.map(item => {
        if (item.audience_interests) {
          audienceInterests = item.audience_interests
        }
        this.topFiveAudienceInterests.push([...audienceInterests].sort((a, b) => b.weight - a.weight).slice(0, 5))
      })
      // console.log('🚀 ~ file: ViewPairingModal.vue ~ line 1421 ~ getTopFiveAudienceInterests ~ this.topFiveAudienceInterests', this.topFiveAudienceInterests)
    },
    saveLineUp () {
      this.updateLineUp()
      this.$swal.fire({
        type: 'success',
        title: 'Saved!',
        showCancelButton: false,
        width: 300
      });
    },
    confirmDelete() {
      let text = "You won't be able to revert this!";
      this.$swal({
        title: 'Are you sure to delete?',
        icon: 'warning',
        showCancelButton: true,
        text
      }).then(result => {
        if (result.value) {
          this.isLoading = true
          for (let item of this.actionSelected) {
            this.executeMethod('delete', item)
          }
          this.isLoading = false
          this.$swal({
            text: 'Successfully Deleted.',
            type: 'success'
          });
          this.clearActionSelected()
        }
      });
    },
    invokeSaveInfData() {
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.saveInfData()
        }
      });
    },
    saveInfData(autoSave = false) {
      // Submit request to save edited pairing data
      let saveData = {
        title: this.infListTitle,
        creatorIds: this.items.map(i => i.pairingID)
      }
      if (this.creator) {
        saveData.id = this.creator.id
      }
      pairingAPIs
      .saveInfListData(saveData)
      .then(response => {
        if (!autoSave) {
          // Show success message
          this.$swal({
            text: 'Influencer List Saved',
            type: 'success'
          });
          this.$emit('reload')
          this.close()
        } else {
          this.$emit('reload')
        }
      })
      .catch(error => {
        // Update submitting status
        this.isEditing = false;
        // Request failed.
        console.log('error', error);
        if (!autoSave) {
          this.$swal({
            text: error,
            type: 'error'
          });
        }
      });
    },
    // async getRateCard(item) {
    //   let influencerID = item.influencerID
    //   this.inputRates = {}
    //   if (influencerID) {
    //     influencerAPIs.getInfluencer(influencerID).then(item => {
    //       this.inputRates = item.inputedRates || {}
    //       if (this.inputRates.pricingDecks && this.inputRates.pricingDecks.length === 0) {
    //         this.isPricingDeskEmpty = true
    //       }
    //     })
    //   }
    //   await this.getRateCardFormLists(item)
    // },
    // async getRateCardFormLists(item) {
    //   this.rateCardFormRates = {}
    //   let filters = {}
    //   if (item.platform) {
    //     if (item.platform === 'tiktok') {
    //       filters.tiktokHandle = item.instagramHandle
    //     } else {
    //       filters.instagramHandle = item.instagramHandle
    //     }
    //   } else filters.instagramHandle = item.instagramHandle
    //   await this.$store.dispatch('influencer/getRateCardLists', { filters })
    //   if (this.rateCards && this.rateCards.length > 0) {
    //     this.rateCardFormRates = this.rateCards[0]
    //   }
    // },
    async getRateCardLists() {
      await this.$store.dispatch('influencer/getRateCardLists', {filters: {}})
    },
    calcMeasurements(newList) {
      this.measurement.total = 0;
      this.measurement.outreach = this.measurement.engagement = this.measurement.budget = 0;
      newList.forEach(item => {
        if (item.eliminationStatus !== this.eliminationStatus.ELIMINATED) {
          // If influencer isn't eliminated
          this.measurement.total += Number(this.calculateContents(item));
          this.measurement.outreach += Number(this.calculateOutreach(item));
          this.measurement.engagement += Number(this.calculateEngagement(item));
          if (item.pairingStatus === this.pairingStatus.ACCEPTED.value) {
            this.measurement.budget += Number(item.payoutAmount || 0);
          }
        }
      });
      this.measurement.outreachPercentage = ((this.measurement.outreach / this.campaign.outreach) * 100).toFixed(2);
      this.measurement.engagementPercentage = ((this.measurement.engagement / this.campaign.engagement) * 100).toFixed(2);
      this.measurement.cogsPercentage = ((this.measurement.budget / this.campaign.budget) * 100).toFixed(2);
      let content = (this.measurement.total / (this.campaign.min_content || this.campaign.min_influencer || 1)) * 100;
      this.measurement.totalPercentage = content > 100 ? 100 : Number(content).toFixed(2);
    },
    getFileType(item) {
      let filename = item.url.substring(item.url.lastIndexOf('/') + 1)
      let fileExt = filename.split('.')[1];

      return fileExt
    },
    async igHandleBulkUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      if (!uploadedFiles || uploadedFiles.length === 0) {
        this.$swal({
          type: 'info',
          text: 'No file uploaded'
        });
        return;
      }
      let handles = await new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.onload = (e) => {
          const tmp = utils.func.parserToJson(e.target.result);
          resolve(tmp)
        };
        fr.readAsArrayBuffer(e.target.files[0]);
        fr.onerror = reject;
      });
      let handleItems = []
      for (const items of handles) {
        for (const record of items) {
          if (record.handle) {
            if (record.type === 'instagram') {
              record.handle = record.handle ? utils.func.espaceHandleSign(utils.func.regexMatchIg(record.handle, globalConfig.regexPattern.instagram_profile)) : ''
            } else if (record.type === 'tiktok') {
              record.handle = record.handle ? utils.func.espaceHandleSign(utils.func.extractTikTokHandle(record.handle)) : ''
            }
            handleItems.push({handle: record.handle, platform: record.type})
          }
        }
      }
      this.uploadBulkHandle(handleItems)
    },
    uploadBulkHandle(handleItems) { // handleItems : array
      if (handleItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          text: 'No Influencer Handle Found'
        });
        return;
      }
      let vm = this
      this.resetBulkProgress()
      this.bulkProgress.show = true
      this.bulkProgress.complete = handleItems.length
      let importSelected = []
      let interval = 100
      handleItems.forEach((el, index) => {
        setTimeout(() => {
          let handleItem = el
          if (vm.selected.find(e => e.handle === handleItem && e.platform === el.platform)) {
            importSelected.push({handle: handleItem.handle, platform: handleItem.platform})
          } else {
            vm.crawlInfluencerDetail(handleItem.handle, handleItem.platform);
            vm.addToSelectedInfluencers(handleItem.handle, handleItem.platform);
            console.log(`🚀 ~ IG Handle: ${handleItem.handle}`)
          }
          this.bulkProgress.processing = index + 1
          if (this.bulkProgress.complete === this.bulkProgress.processing) {
            this.bulkProgress.show = false
            this.showAlreadySelectedAlert(importSelected)
          }
        }, index * interval);
      });
      this.$refs.igBulkHandle.value = null;
    },
    showAlreadySelectedAlert(importSelected) {
      if (importSelected.length > 0) { // if already selected exists, show after completed
        let displayBlock = ''
        importSelected.map(a => {
          displayBlock += `<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">
            <span class="v-chip__content">${a}</span>
          </span>`
        })
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: `Influencers being selected: <div>${displayBlock}</div>`
        });
      }
      return;
    },
    resetBulkProgress() {
      this.bulkProgress.processing = 0
      this.bulkProgress.complete = 0
      this.bulkProgress.show = false
    },
    openEditItem(itemID, itemName) {
      if (this.disableLockedCOGS) {
        return
      }
      let index = this.items.findIndex(i => i.pairingID === itemID)
      if (itemName === 'payout') {
        if (this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return
        }
      }
      if (itemName === 'status') {
        if (this.campaign.lockedCOGS || this.items[index].payoutStatus === this.payoutStatus.CONFIRMED) {
          return
        }
      }
      this.items[index][itemName + 'Edit'] = true
      this.items[index].editPairing = true
      this.oldEditItem = utils.func.refreshJSON(this.items[index])
      this.disableSaveEdit = false
    },
    cancelEdit() {
      this.items = this.items.map(inf => {
        inf = this.initEditFields(inf)
        return inf
      })
      this.disableSaveEdit = true
    },
    initEditFields(inf) {
      inf.remarkEdit = false;
      inf.payoutEdit = false;
      inf.statusEdit = false;
      inf.editPairing = false;
      return inf
    },
    changeBulkPairingStatus(status) {
      let items = utils.func.refreshJSON(this.items)
      items = items.map(i => {
        if (i.isDelete) {
          i.pairingStatus = status;
          i.editPairing = true
        }
        return i;
      })
      this.saveEditingData(items)
    },
    selectAllPairings($event) {
      if (!$event.value) {
        this.items = this.items.map(i => { i.isDelete = false; return i; })
      } else {
        this.items = this.items.map(i => {
          i.isDelete = true
          return i;
        })
      }
      this.actionSelectChange()
    },
    updatePairingDisplayStatus() {
      let data = Object.assign({}, {
        pairingDisplayStatus: this.campaign.pairingDisplayStatus
      })
      let formData = new FormData();
      formData.append('data', JSON.stringify(data));
      // Submit request to upload file
      campaignAPIs
        .updatePairingDisplayStatus(this.campaign.id, formData)
        .then(response => {
          console.log('successfully updated!')
        })
      .catch(error => {
        // Request failed.
        console.log('error', error);
        this.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    displayFields(field) {
      // if (this.campaign.pairingDisplayStatus !== undefined) {
      //   if (this.campaign.pairingDisplayStatus[field]) {
      //     return true
      //   }
      // }
      // return false
      return true
    },
    renderRemark(remark) {
      if (remark !== undefined && remark !== null) {
        return remark.replace(/\n/g, '<br>');
      }
      return '-'
    },
    downloadSampleUpload() {
      var link = document.createElement('a');
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_bulkupload.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        let ret = []
        let male = audienceGenders.find(a => a.code === 'MALE')
        if (male) ret.push(male)
        let female = audienceGenders.find(a => a.code === 'FEMALE')
        if (female) ret.push(female)
        return ret.map(gender => (gender.weight * 100).toFixed(2))
      }
    },
    displayGSTText(item) {
      if (item.isGST) {
        return `$${item.payoutAmount + parseFloat(item.GSTpercent || 0)} (If GST Included)`
      }
      return item.min_payout ? '$' + (item.min_payout) + ' - $' + (item.max_payout) : '$' + (item.max_payout)
    },
    openLockedPayoutEditDialog(item) {
      this.lockedPayout = true
      this.payoutEditPairing = item
      this.editPayoutDialog = true
    },
    openLockedCOGSDialog(item) {
      this.$swal({
        title: 'Send Unlock Request',
        html: 'Are you sure to send request to unlock COGS?',
        confirmButtonText: 'Send',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          const reqData = {
            campaignID: item.id
          }
          await this.$store.dispatch('pairing/requestPayoutEdit', reqData)
          if (this.requestedPayoutEdit) {
            this.$swal({
              text: 'Successfully Requested.',
              type: 'success'
            })
          }
        }
      })
    },
    async changeLock(item, status) {
      const lockTxt = status ? 'Lock' : 'Unlock'
      this.$swal({
        title: `Are you sure to ${lockTxt}?`,
        icon: 'warning',
        confirmButtonText: lockTxt,
        showCancelButton: true
      }).then(async (result) => {
        if (result.value) {
          let updateObj = {
            id: item.id,
            lockedCOGS: status
          }
          if (status === false) {
            updateObj.unlockCogsEmail = true
          }
          const updateData = [
            updateObj
          ]
          await this.$store.dispatch('campaign/updateCampaignByIds', updateData)
          if (!this.campaignUpdated) {
            this.$swal({
              text: 'Error Campaign Update.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: `Successfully ${lockTxt}ed.`,
            type: 'success'
          });
          item.lockedCOGS = status
          // this.getCampaigns()
        }
        this.getPairedInfluencers(this.campaign.id)
      })
    },
    savedGetApproval() {
      this.getPairedInfluencers(this.campaign.id)
    },
    openPayoutEditDialog(item) {
      this.lockedPayout = false
      this.payoutEditPairing = item
      this.editPayoutDialog = true
    },
    openReqApprovalDialog(updateData) {
      this.reqAmt = Number(updateData.amount)
      this.reqReasons = updateData.reasons
      this.reqApprovalDialog = true
    },
    checkOpenPayoutEditDialog() {
      // this will check from route params to open payout confirmation dialog by given handle
      if (this.$route.query.payoutConfirm && this.$route.query.handle) {
        let handle = this.$route.query.handle
        let matchItem = this.filteredItems.find(f => f.userHandle === handle)
        if (matchItem) {
          if (matchItem.payoutStatus === this.payoutStatus.CONFIRMED) {
            this.openLockedPayoutEditDialog(matchItem)
          } else {
            this.openPayoutEditDialog(matchItem)
          }
        }
      }
    },
    changePairingStatus(item) {
      if (item.pairingStatus === config.pairingStatus.ACCEPTED) {
        const totalDeliverables = campaignHelper.getTotalDeliverables(item.deliverableDetails)
        if (totalDeliverables <= 0) {
          this.$swal({
            text: `Please submit deliverables to accept.`,
            type: 'warning'
          });
          // set old pairing status if no deliverables submitted.
          this.items = this.items.map(i => {
            if (i.pairingID === item.pairingID) {
              if (this.oldEditItem) {
                i.pairingStatus = this.oldEditItem.pairingStatus
                i.statusEdit = false
              }
            }
            return i
          })
          return
        }
        if (item.payoutAmount === 0) {
          this.$swal({
            html: `The Payout is 0$.<br>Please confirm this creator doesn’t need payment.`,
            type: 'warning'
          });
        }
      }
    },
    openRateCardView(rateCard) {
      window.open(`/influencers/rate-cards?id=${rateCard.id}`, '_blank')
    },
    changePairingColEdit(colName, item, status) {
      let matchItemIdx = this.items.findIndex(f => f.pairingID === item.pairingID)
      if (matchItemIdx !== -1) {
        this.items[matchItemIdx][colName] = status
        this.items = utils.func.refreshJSON(this.items)
      }
    },
    async updatePairingCol(item, field) {
      this.isLoading = true
      let updatePairings = []
      if (field === 'gender') {
        item.influencer_details.gender = item.gender
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'age_group') {
        item.influencer_details.age_group = item.age_group
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'topAudAges') {
        if (!item.influencer_details.audAges) {
          item.influencer_details.audAges = []
        }
        // clear up manual items first to set new manuals
        item.influencer_details.audAges = item.influencer_details.audAges.filter(c => !c.manual)
        // remove lineupindex  to reorder
        item.influencer_details.audAges = item.influencer_details.audAges.map(a => {
          delete a.lineupIndex
          return a
        })
        let idx = 1
        for (let fieldItem of item[field]) {
          let matchItemIdx = item.influencer_details.audAges.findIndex(a => a.code === fieldItem)
          if (matchItemIdx !== -1) {
            item.influencer_details.audAges[matchItemIdx].lineupIndex = idx
          } else {
            // if no aud ages match, create manual one
            item.influencer_details.audAges.push({
              code: fieldItem,
              weight: 0,
              lineupIndex: idx,
              manual: true
            })
          }
          idx += 1
        }
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      if (field === 'topCountries') {
        if (!item.influencer_details.countries) {
          item.influencer_details.countries = []
        }
        item.influencer_details.countries = item.influencer_details.countries.filter(c => !c.manual)
        item.influencer_details.countries = item.influencer_details.countries.map(a => {
          delete a.lineupIndex
          return a
        })
        let idx = 1
        for (let fieldItem of item[field]) {
          let matchItemIdx = item.influencer_details.countries.findIndex(a => a.name === fieldItem)
          if (matchItemIdx !== -1) {
            item.influencer_details.countries[matchItemIdx].lineupIndex = idx
          } else {
            item.influencer_details.countries.push({
              name: fieldItem,
              weight: 0,
              lineupIndex: idx,
              manual: true
            })
          }
          idx += 1
        }
        updatePairings.push({
          id: item.pairingID,
          'influencer_details': item.influencer_details
        })
      }
      let formData = new FormData();
      formData.append('pairings', JSON.stringify(updatePairings));
      let resp = await pairingAPIs.updatePairings(formData)
      if (resp) {
        let matchItemIdx = this.items.findIndex(f => f.pairingID === item.pairingID)
        if (matchItemIdx !== -1) {
          this.items[matchItemIdx][field] = item[field]
          if (field === 'topAudAges') {
            item.influencer_details.audAges = sortBy(item.influencer_details.audAges, 'lineupIndex')
            this.items[matchItemIdx].audAges = Object.assign([], item.influencer_details.audAges)
            this.items[matchItemIdx].audAgesDisplay = Object.assign([], this.items[matchItemIdx].audAges.splice(0, item.topAudAges.length))
            this.items[matchItemIdx].audAgesEdit = false
          }
          if (field === 'topCountries') {
            item.influencer_details.countries = sortBy(item.influencer_details.countries, 'lineupIndex')
            this.items[matchItemIdx].countries = Object.assign([], item.influencer_details.countries)
            this.items[matchItemIdx].topCountryDisplay = Object.assign([], this.items[matchItemIdx].countries.splice(0, item.topCountries.length))
            this.items[matchItemIdx].audCountryEdit = false
          }
          if (field === 'gender') {
            this.items[matchItemIdx].genderEdit = false
            this.items[matchItemIdx].influencer_details.gender = item.influencer_details.gender
          }
          if (field === 'age_group') {
            this.items[matchItemIdx].ageGroupEdit = false
            this.items[matchItemIdx].influencer_details.age_group = item.influencer_details.age_group
          }
          let tmp = Object.assign([], this.items)
          this.items = []
          this.items = utils.func.refreshJSON(tmp)
        }
      }
      this.isLoading = false
    },
    checkSelectLimit(item, field) {
      if (item[field].length > 2) {
        item[field].pop()
      }
    },
    resetData() {
      this.infListTitle = 'Untitled'
      this.igHandle = ''
      this.items = []
      this.selected = []
    }
  }
};
</script>
<style scoped>
.custom-font {
  font-size: 16px;
  font-weight: 500;
  color: #eee;
}
.danger {
  color: black;
  background-color: #fff176;
}
.danger:hover {
  background-color: #ff5722;
}
.not-in-ims {
  text-decoration: line-through;
}
.move-cursor {
  cursor: move;
  float: left;
  margin-top: 25px;
}
.multi-select-checkbox {
  display: inline;
  float: left;
  padding: 0;
  margin-top: 21px;
}
.btn-reload {
  margin-top: 23px;
  padding: 0!important;
  min-width: 10px!important;
}
.page__table tbody td {
  padding: 5px!important;
}
.page__table tbody td .input-field {
  font-size:13px;
}
.deliverable-txt {
  inline-size: 150px;
  overflow-wrap: break-word;
}
</style>
<style>
  .page__table .v-simple-checkbox {
    text-align: center
  }
  .page__table tbody td .remark-text {
    display: -webkit-box;
    max-width: 200px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .page__table .multi-select-more-btn {
    background-color: #fff;
    color: #3f3f3f!important;
  }
  .page__table .multi-select-more-btn:hover {
    background: none;
    color: #3F3FFF!important;
    transition: 0.5s;
  }
  .pairing-list-title-input .v-label,
  .pairing-list-title-input input {
    color: var(--ims-color-secondary) !important;
  }
  .pairing-list-title-input input {
    caret-color: var(--ims-color-secondary) !important;
  }
  .pairing-list-title-input .v-input__slot:before,
  .pairing-list-title-input .v-input__slot:after {
    border-color: rgba(63, 63, 255, 0.72) !important;
  }
</style>



// WEBPACK FOOTER //
// ViewInfluencerListModal.vue?ef8a0806